import moment from 'moment-timezone'

const TAIWAN_TZ = 'Asia/Taipei'

export function toTaiwanISOString(date) {
  return moment(date).tz(TAIWAN_TZ).toISOString()
}

// 台灣的今天（YYYY-MM-DD）；人在國外時，電腦的日期可能還是前一天
export function taiwanToday() {
  return moment().tz(TAIWAN_TZ).format('YYYY-MM-DD')
}

export function fromTaiwanTimestamp(ts) {
  return moment.tz(ts * 1000, TAIWAN_TZ).toDate()
}

export function toUnixFromTaiwan(date) {
  return moment.tz(date, TAIWAN_TZ).unix()
}

export function forceTaiwanTimestamp(unixSeconds) {
  const TAIWAN_OFFSET_MIN = -480
  const localOffset = new Date().getTimezoneOffset() // ex: 台灣是 -480，東京 -540，美西 +420
  const delta = (localOffset - TAIWAN_OFFSET_MIN) * 60 * 1000
  return unixSeconds * 1000 + delta
}